import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateBrokerClosingReasons } from "@/shared/store/LenderCallLog/BrokerClosingReasons";

const getBrokerClosingReasons = sharedService.injectEndpoints({
  endpoints: builder => ({
    getBrokerClosingReasons: builder.query({
      query: () => "parameters/lender-call-log-broker-closing-reasons",
      transformResponse: response => response.items,
      providesTags: ["BrokerClosingReasons"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateBrokerClosingReasons(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetBrokerClosingReasonsQuery } = getBrokerClosingReasons;

